import { BookingWaitList, BookingWaitListServer } from '../store/types';

export const adapteWaitingList = (waitingList: BookingWaitListServer): BookingWaitList => (
  waitingList.map((waitingsInfo) => ({
    time: waitingsInfo['time'],
    entries: waitingsInfo.entries.map((waitingInfo) => ({
      userEmail: waitingInfo['user_email'],
      userId: waitingInfo['user_id'],
      userName: waitingInfo['user_name'],
      userPhone: waitingInfo['user_phone'],
      id: waitingInfo.id,
      note: waitingInfo.note,
      startTime: waitingInfo['start_time'],
      endTime: waitingInfo['end_time'],
    }))
  }))
);
